<template>
  <a-modal
    v-model="mainVisible"
    class="modal"
    :maskClosable ="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
  <div slot="title" class="tip-icon"> {{title}} </div>
    <div class="message">
        <a-form-model ref="ruleForm" :model="content" :rules="rules">
            <a-form-model-item label="审核意见" prop="comments" >
              <a-input v-model="content.comments"   placeholder="请输入审核意见" type="textarea" />
            </a-form-model-item>
        </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="btaction" @click="handleOk" :loading="disabled"
        >确 定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import {
  reviewAgree,
  reviewReject,
} from "@/api/api.js"
import { DictionaryService } from '@common/services/dictionary.service'
export default {
  name: "roleAddModal",
  props: ["visible", "userData", "title", "type"],
  data() {
    return {
      //数据字典
      usrRTList: [],
      usrRSList: [],
      //参数
      content: {
        comments: '',
      },
      disabled: false,
      mainVisible:this.visible,
      //校验规则
      rules: {
      comments: [
        {
            required: true,
            message: "审核意见不能为空！",
            trigger: "blur",
        },
        {
            max: 180,
            message: "审核意见长度不能超过180",
        },
      ],
      },
    };
  },
  created() {
    this.$set(this.content, "id", this.userData.id);
  },
  mounted() {
      //查询数据字典
      DictionaryService.getAllNeedDic(["ROLE_TYPE","ROLE_STATUS"]).then((res) => {
        this.usrRTList = DictionaryService.getOptions("ROLE_TYPE");
        this.usrRSList = DictionaryService.getOptions("ROLE_STATUS");
      });
  },
  methods: {
    handleOk(e) {//弹窗确定
    this.$refs.ruleForm.validate((valid) => {
      if (valid) {
        this.disabled = true;
        let pageParam = {
          pageNum: 0,
          pageSize: 0,
          orderBy: "",
        };
        if(this.type == "pass"){
          reviewAgree({
              id: this.content.id,
              comments:this.content.comments,
            }).then(
                (res) => {
                    if (res.code == "0000") {
                        this.disabled = false;
                        this.success("审核成功");
                        this.$emit("close");
                        this.$emit("queryList");
                    }
                },
                (err) => {
                  this.disabled = false;
                }
            );
        } else if(this.type == "refuse"){
          reviewReject({
            id: this.content.id,
            comments:this.content.comments,
          }).then(
              (res) => {
                  if (res.code == "0000") {
                      this.disabled = false;
                      this.success("审核成功");
                      this.$emit("close");
                      this.$emit("queryList");
                  }
              },
              (err) => {
                this.disabled = false;
              }
          );
        } 
        }
      });
    },
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
      this.$refs["ruleForm"].resetFields();
    },
    success(title) {
      //提示
      this.$message.success(title, 3);
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.message {
  width: 100%;
  height: auto;
  
  .ant-form-item{
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label{
    width: 120px;
  }
  /deep/ .ant-form-item-control{
    width: 350px;
  }
  /deep/ .input-number-order{
    width: 350px;
  }
}
</style>